import React, { useState, useEffect } from "react";
import "../../css/bootstrap.min.css";
import axios from "axios";
import { FaBars, FaEnvelope, FaPowerOff } from "react-icons/fa"

export default function TopNavigation({ setLoggedIn }) {
  const [requests, setRequests] = useState([]);
  const [numRequests, setNumRequests] = useState(0)
  useEffect(() => {
    const fetchRequests = async () => {
      const response = await axios.get('/api/partnerrequest/getPending')
      const { numRequests, partnerRequests } = response.data
      partnerRequests.length = 5
      setRequests(partnerRequests)
      setNumRequests(numRequests)
    }
    fetchRequests()
  }, [])

  const logout = () => {
    setLoggedIn(false);
    // localStorage.setItem(
    //   "logged_in_token",
    //   JSON.stringify({
    //     logged_in: false,
    //   })
    // );
  };

  return (
    <nav className="navbar-static-top pb-1 pt-3">
      <div className="nav-actions pb-2 d-lg-none d-xl-none">
        <FaBars size={18} color="#1872ab" />
      </div>
      <div className="d-lg-block d-xl-block"></div>
      <div className="top-nav-links">
        <div className="nav-actions mx-4">
          <div className="partner-dropdown">
            <span className="fa-stack fa-1x" data-count={numRequests}>
              <FaEnvelope size={18} color="#1872ab" />
            </span>
            <div className="partner-dropdown-content dropdown-message-box px-0">
              {
                requests.map((request, index) => (
                  <li className="dropdown-item" key={index}>
                    <a className="dropdown-item" href={`/newrequest/${request._id}`}>
                      <small className="text-success">
                        {"New request from " +
                          request.first_name +
                          " " +
                          request.last_name}
                      </small>
                    </a>
                  </li>
                ))
              }
            </div>
          </div>

        </div>
        <div className="nav-actions pb-2">
          <a href="/" onClick={logout} data-tooltip="Logout" className="d-flex align-items-center">
            <FaPowerOff size={18} />
            <span className="log-out"> Log out</span>
          </a>
        </div>
      </div>
    </nav>
  );
}
